import type { Theme } from '../types/theme';

export const THEME_CATEGORIES = [
  'AI & LLM',
  'Developer Tools',
  'Backend & DevOps',
  'Productivity',
  'Design & Creative',
  'Finance & Commerce',
  'Consumer & Media',
  'Automotive',
  'Enterprise & Cloud',
] as const;

export type ThemeCategory = typeof THEME_CATEGORIES[number];

const categoryByThemeId: Record<string, ThemeCategory> = {
  claude: 'AI & LLM',
  cohere: 'AI & LLM',
  elevenlabs: 'AI & LLM',
  minimax: 'AI & LLM',
  mistral: 'AI & LLM',
  ollama: 'AI & LLM',
  opencode: 'AI & LLM',
  replicate: 'AI & LLM',
  runwayml: 'AI & LLM',
  together: 'AI & LLM',
  voltagent: 'AI & LLM',
  xai: 'AI & LLM',

  cursor: 'Developer Tools',
  expo: 'Developer Tools',
  fig: 'Developer Tools',
  lovable: 'Developer Tools',
  raycast: 'Developer Tools',
  superhuman: 'Developer Tools',
  vercel: 'Developer Tools',
  warp: 'Developer Tools',

  azure: 'Enterprise & Cloud',
  cloudflare: 'Enterprise & Cloud',
  datadog: 'Enterprise & Cloud',
  ibm: 'Enterprise & Cloud',
  sentry: 'Enterprise & Cloud',

  clickhouse: 'Backend & DevOps',
  composio: 'Backend & DevOps',
  hashicorp: 'Backend & DevOps',
  mongodb: 'Backend & DevOps',
  posthog: 'Backend & DevOps',
  sanity: 'Backend & DevOps',
  supabase: 'Backend & DevOps',

  airtable: 'Productivity',
  cal: 'Productivity',
  intercom: 'Productivity',
  linear: 'Productivity',
  mintlify: 'Productivity',
  notion: 'Productivity',
  resend: 'Productivity',
  slack: 'Productivity',
  zapier: 'Productivity',

  figma: 'Design & Creative',
  framer: 'Design & Creative',
  miro: 'Design & Creative',
  pinterest: 'Design & Creative',
  webflow: 'Design & Creative',

  airbnb: 'Finance & Commerce',
  binance: 'Finance & Commerce',
  coinbase: 'Finance & Commerce',
  revolut: 'Finance & Commerce',
  shopify: 'Finance & Commerce',
  stripe: 'Finance & Commerce',
  uber: 'Finance & Commerce',

  apple: 'Consumer & Media',
  nvidia: 'Consumer & Media',
  playstation: 'Consumer & Media',
  spacex: 'Consumer & Media',
  spotify: 'Consumer & Media',
  tesla: 'Consumer & Media',
  verge: 'Consumer & Media',
  vodafone: 'Consumer & Media',
  wired: 'Consumer & Media',

  bmw: 'Automotive',
  bugatti: 'Automotive',
  ferrari: 'Automotive',
  lamborghini: 'Automotive',
  renault: 'Automotive',
};

export function getThemeCategory(theme: Theme): ThemeCategory {
  return categoryByThemeId[theme.id] || 'Productivity';
}

export function getThemeSearchText(theme: Theme): string {
  return [
    theme.name,
    theme.description,
    getThemeCategory(theme),
    theme.mood.tone,
    theme.mood.density,
    ...theme.visualKeywords,
    ...theme.mood.bestFor,
    ...theme.mood.notGoodFor,
    ...theme.mood.productFit,
  ].join(' ').toLowerCase();
}
